import { Slider } from './slider';

export class RoomSlider extends Slider {
	classes = {
		...this.classes,
		sliderOpened: 'room__slider--opened',
	};
	constructor(root) {
		const slider = root.querySelector('#slider');
		super(slider, slider.dataset.imagesNum, slider.dataset.itemClass);
		this.root = root;
		this.roomBtn = this.root.querySelector('#closeSliderBtn');
		this.isOpened = this.root.classList.contains(this.classes.sliderOpened);
		this.photos = document.querySelectorAll('#photosImg');
		this.photosItems = document.querySelectorAll('#photosItem');
		this.init();
	}

	_addHandlers() {
		super._addHandlers();
		this.roomBtn.addEventListener('click', this._handleRoomBtnClick);
		this.photosItems.forEach(photo =>
			photo.addEventListener('click', this._handlePhotoClick)
		);
	}

	_openRoomSlider() {
		document.documentElement.style.overflow = 'hidden';
		this.root.classList.add(this.classes.sliderOpened);
		document.addEventListener('click', this._handleOutsideClick);
	}

	_handleOutsideClick = e => {
		if (e.target.closest('#slider')) return;
		this._closeRoomSlider();
		document.removeEventListener('click', this.boundHandleOutsideClick);
	};

	_closeRoomSlider() {
		document.documentElement.style.overflow = 'auto';
		this.root.classList.remove(this.classes.sliderOpened);
	}

	_handlePhotoClick = e => {
		e.stopPropagation();
		const id = e.target.closest('#photosItem').querySelector('#photosImg')
			.dataset.imgNum;
		if (this.isOpened) this._closeRoomSlider();
		else this._openRoomSlider();
		this.setActiveImage(+id);
	};

	_handleRoomBtnClick = () => {
		const { sliderOpened } = this.classes;
		if (this.isOpened) this.root.classList.add(sliderOpened);
		else this.root.classList.remove(sliderOpened);
	};
}
